// extracted by mini-css-extract-plugin
export default {"home":"Home_home__38vP9","subtitle":"Home_subtitle__f5W2i","txt-body":"Home_txt-body__mGQz1"};